export const tagList = [
  "지식",
  "실전",
  "직장인",
  "사업자",
  "대출 기초",
  "대출 중급",
  "부동산 기초",
  "부동산 중급",
  "재테크 기초",
  "재테크 중급",
  "경제 기초",
];
